(() => {
  if (customElements.get('hitch-cart-recommendations')) return;
  let nextInstanceId = 0;

  class HitchCartRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || !this.dataset.url) return;
      this.instanceId = ++nextInstanceId;
      this.dataset.loaded = 'true';
      fetch(this.dataset.url)
        .then((response) => {
          if (!response.ok) throw new Error(`Recommendations request failed: ${response.status}`);
          return response.text();
        })
        .then((responseText) => {
          if (!this.isConnected) return;
          const documentFragment = new DOMParser().parseFromString(responseText, 'text/html');
          const content = documentFragment.querySelector('[data-hitch-cart-recommendations-content]');
          if (!content) {
            this.remove();
            return;
          }

          const ids = new Map();
          content.querySelectorAll('[id]').forEach((element) => {
            const oldId = element.id;
            const newId = `${oldId}-HitchCart-${this.instanceId}`;
            element.id = newId;
            ids.set(oldId, newId);
          });
          content.querySelectorAll('[aria-labelledby], [aria-controls], [aria-describedby], [for], [form], [data-modal]').forEach((element) => {
            ['aria-labelledby', 'aria-controls', 'aria-describedby', 'for', 'form'].forEach((attribute) => {
              const value = element.getAttribute(attribute);
              if (!value) return;
              element.setAttribute(attribute, value.split(/\s+/).map((id) => ids.get(id) || id).join(' '));
            });
            const modalId = element.getAttribute('data-modal');
            if (modalId?.startsWith('#') && ids.has(modalId.slice(1))) {
              element.setAttribute('data-modal', `#${ids.get(modalId.slice(1))}`);
            }
          });
          content.querySelectorAll('quick-add-modal.hitch-cart-quick-add-modal').forEach((modal) => {
            modal.dataset.hitchCartOwner = this.instanceId;
          });

          this.replaceChildren(content);
          this.excludedProductIds?.forEach((productId) => this.excludeProduct(productId));
        })
        .catch(() => {
          if (this.isConnected) this.remove();
        });
    }

    disconnectedCallback() {
      if (!this.instanceId) return;
      queueMicrotask(() => {
        if (this.isConnected) return;
        document
          .querySelectorAll(`quick-add-modal.hitch-cart-quick-add-modal[data-hitch-cart-owner="${this.instanceId}"]`)
          .forEach((modal) => {
            if (modal.hasAttribute('open')) modal.hide(true);
            modal.remove();
          });
      });
    }

    excludeProduct(productId) {
      if (!productId) return;
      this.excludedProductIds ??= new Set();
      this.excludedProductIds.add(String(productId));
      this.querySelectorAll('[data-hitch-product-id]').forEach((card) => {
        if (card.dataset.hitchProductId === String(productId)) card.remove();
      });
      if (this.querySelector('[data-hitch-cart-recommendations-content]') &&
          !this.querySelector('.hitch-cart-recommendations__item')) {
        const section = this.closest('#shopify-section-hitch-cart-drawer-recommendations');
        if (section) section.hidden = true;
      }
    }
  }

  customElements.define('hitch-cart-recommendations', HitchCartRecommendations);

  // Dawn replaces the drawer markup on cart changes. Keep the loaded recommendations
  // node so its cards and horizontal scroll position survive those updates.
  window.hitchReplaceCartSection = (target, html, addedProductId) => {
    const existing = target.querySelector('#shopify-section-hitch-cart-drawer-recommendations');
    const scrollContainer = target.matches('.drawer__inner') ? target : target.querySelector('.drawer__inner');
    const scrollTop = scrollContainer?.scrollTop;
    if (!existing) {
      target.innerHTML = html;
      return;
    }

    const template = document.createElement('template');
    template.innerHTML = html;
    const replacement = template.content.querySelector('#shopify-section-hitch-cart-drawer-recommendations');
    if (replacement) replacement.replaceWith(existing);
    target.replaceChildren(template.content);
    if (replacement) existing.querySelector('hitch-cart-recommendations')?.excludeProduct(addedProductId);
    const updatedScrollContainer = target.matches('.drawer__inner') ? target : target.querySelector('.drawer__inner');
    if (updatedScrollContainer && scrollTop) updatedScrollContainer.scrollTop = scrollTop;
  };

  document.body.addEventListener('modalClosed', () => {
    const modal = document.querySelector('quick-add-modal.hitch-cart-quick-add-modal[open]');
    const drawer = document.querySelector('cart-drawer.active');
    if (!modal || !drawer) return;

    const isSubmitting = Boolean(modal.querySelector('button[type="submit"].loading'));
    queueMicrotask(() => {
      if (!drawer.classList.contains('active')) return;
      document.body.classList.add('overflow-hidden');
      if (!isSubmitting && modal.openedBy?.isConnected) {
        trapFocus(drawer.querySelector('#CartDrawer'), modal.openedBy);
      }
    });
  });
})();
